import axios from 'axios';
import { AUTH_COOKIE_NAME, EXTERNAL_USERS_ROLES, USER_ROLES, USER_SUPER_ADMIN_ROLE } from 'src/constants';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const roles = [...EXTERNAL_USERS_ROLES, ...USER_ROLES, USER_SUPER_ADMIN_ROLE];

export const setJWTCookie = (token: string, exp: number): void => {
  cookies.set(AUTH_COOKIE_NAME, token, {
    path: '/',
    expires: new Date(exp * 1000),
  });
  setAuthToken(token);
};

export const removeJWTCookie = (): void => {
  cookies.remove(AUTH_COOKIE_NAME, { path: '/' });
  delete axios.defaults.headers.common.Authorization;
};

export const setAuthToken = (token: string): void => {
  axios.defaults.headers.common.Authorization = `Bearer ${token}`;
};

export const isHigherUser = (roleToCheck: string, userRole?: string): boolean => {
  const currentRoleWeight = roles.find((role) => role.value === userRole?.toLowerCase())?.weight;
  const roleToCheckWeight = roles.find((role) => role.value === roleToCheck)?.weight;
  if (!currentRoleWeight || !roleToCheckWeight) {
    return false;
  }
  return currentRoleWeight > roleToCheckWeight;
};
